import * as React from 'react';

import { OffsetScrollDiv } from '../styled';

export const OffsetScroll: React.FC = () => {
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (ref.current) {
      ref.current.scrollIntoView(true);
    }
  }, []);
  return <OffsetScrollDiv ref={ref} />;
};
